import { Component } from '@angular/core';

import { AmpAppShell } from '@amp/shared/app-shell';

@Component({
  selector: 'amp-root',
  template: '<amp-app-shell />',
  imports: [AmpAppShell],
})
export class App {}
